module.exports = __webpack_public_path__ + "static/media/settings_web-form.1456fc58.svg";